import {
  Result,
  RESULT_VARIANT_ERROR,
  RESULT_VARIANT_SUCCESS,
} from '@sgcmpteltd/uikit-react/components/result';

import type { Component } from './types';

export const Step: Component = ({
  isSuccess,
  message,
  title,
}) => (
  <Result
    message={message}
    title={title}
    variant={
      isSuccess
        ? RESULT_VARIANT_SUCCESS
        : RESULT_VARIANT_ERROR
    } />
);
